import { ITheme } from "smarthub-common";
import { IProps } from "../props";
import { lightTheme } from "./light.theme";

const personalityMapping = {
  Generic: [lightTheme],
};

export const themes = ({ personality }: IProps): ITheme[] =>
  personalityMapping[personality];
